import NP from "number-precision";
import { HttpService } from "@/core";
import { ExportResp } from "@/core/interface";
import { QuantityDetailResp, QuantityReq, QuantityImportResp } from "./quantity-table.interface";

export class QuantityTableService {
  static useQuantityCreateApi() {
    const api = (changeId: string, data: QuantityReq) =>
      HttpService.axios({
        method: "POST",
        url: `/subcontract/${changeId}/quantities`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useQuantityUpdateApi() {
    const api = (changeId: string, data: QuantityReq) =>
      HttpService.axios({
        method: "POST",
        url: `/subcontract/${changeId}/quantitiesList`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useQuantityListApi() {
    const api = (changeId: string, name: string) =>
      HttpService.axios({
        method: "GET",
        url: `/project_work_budget_quantities/list?validStatus=ysx&projectId=${changeId}&name=${name}`,
      });
    return HttpService.useRequest<QuantityDetailResp>(api);
  }
  static useQuantityDetailApi() {
    const api = (changeId: string) =>
      HttpService.axios({
        method: "GET",
        // 更改获取工程量清单数量
        url: `/subcontract/quantities?id=${changeId}&current=1&size=1500`,
        // url: `/subcontract/quantities`,
      });
    return HttpService.useRequest<QuantityDetailResp>(api);
  }

  static useQuantityImportApi() {
    const api = (changeId: string, url: string) =>
      HttpService.axios({
        method: "POST",
        // url: `/subcontract/${changeId}/import/quantities`,
        url: `/subcontract/import/quantities`,
        data: { url },
      });
    return HttpService.useRequest<QuantityImportResp>(api);
  }

  static useQuantityExportApi() {
    const api = (changeId: []) =>
      HttpService.axios({
        method: "GET",
        url: `/subcontract/export/quantities?ids=${changeId}`,
      });
    return HttpService.useRequest<ExportResp>(api, { isOutError: true });
  }

  static calcQuantities(quantities) {
    return (quantities || []).map((item) => {
      // 本次变更.合价 = 本次变更.工程量 * 本次变更.单价
      item.changeTotalPrice = NP.times(item.changeCount || 0, item.changePrice || 0);
      // 本次变更后.工程量 = 当前合同.工程量 + 本次变更.工程量
      item.afterChangeCount = NP.plus(item.count || 0, item.changeCount || 0);
      // 本次变更后.合价 = 当前合同.合价 + 本次变更后.合价
      item.afterChangeTotalPrice = NP.plus(item.totalPrice || 0, item.changeTotalPrice || 0);
      // 本次变更后.单价 = 当前合同.单价 + 本次变更.单价
      if (item.afterChangeCount !== 0) {
        item.afterChangePrice = NP.divide(
          item.afterChangeTotalPrice || 0,
          item.afterChangeCount || 0
        );
      }
      return item;
    });
  }
}
